import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { CancelButton, DBDropDown, DBTextField, DBCheckBox, RedoButton } from '_components';
import styles from './Common.module.css';


class AlSelfCareRow extends React.Component {

    remove() {
        this.props.removeChildRow(this.props.noteId, 'MLSELFCARE', 'XLSC', this.props.selfcare.XLSCNO);
    }

    handlePerformed(val) {
        if (!this.props.onAssessment && val === true) {
            this.props.updateBitField(this.props.noteId, 'PTPLAN', 'PLNO', this.props.plno, 'PLSELFCARE', true);
        }
        if (this.props.computedChargesVisible) {
            this.props.hideComputedCharges({ noteId: this.props.noteId });
        }
    }

    render() {
        return (
            <span>
                <div className={this.props.selfcare.XLSCPERFORMED ? styles.row_performed : styles.row}>
                    <div className={styles.remove_button}>
                        <CancelButton title='Remove' size='extra-small' onClick={() => this.remove()} />
                    </div>
                    <div className={styles.cell_wrapper}>
                        <DBDropDown
                            field='XLSCSCNO'
                            noteId={this.props.noteId}
                            entity='MLSELFCARE'
                            entityKeyColumn='XLSCNO'
                            entityKeyValue={this.props.selfcare.XLSCNO}
                            className={this.props.selfcare.XLSCPERFORMED && !this.props.selfcare.XLSCSCNO ? styles.col1_performed : styles.col1}
                            customOptions={this.props.activities}
                        />
                    </div>
                    <div className={styles.cell_wrapper}>
                        <DBTextField
                            noteId={this.props.noteId}
                            entity='MLSELFCARE'
                            entityKeyColumn='XLSCNO'
                            entityKeyValue={this.props.selfcare.XLSCNO}
                            field='XLSCACTIVITY'
                            className={this.props.selfcare.XLSCPERFORMED && !this.props.selfcare.XLSCACTIVITY ? styles.col2_performed : styles.col2}
                        />
                    </div>
                    <div className={styles.cell_wrapper}>

                        <DBTextField
                            noteId={this.props.noteId}
                            entity='MLSELFCARE'
                            entityKeyColumn='XLSCNO'
                            entityKeyValue={this.props.selfcare.XLSCNO}
                            field='XLSCSETSREPS'
                            className={this.props.selfcare.XLSCPERFORMED && !this.props.selfcare.XLSCSETSREPS ? styles.col3_performed : styles.col3}
                        />
                    </div>
                    <div className={styles.cell_wrapper}>

                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='MLSELFCARE'
                            entityKeyColumn='XLSCNO'
                            entityKeyValue={this.props.selfcare.XLSCNO}
                            field='XLSCPERFORMED'
                            className={styles.col4}
                            disabled={this.props.performedDisabled}
                            onClick={(val) => this.handlePerformed(val)}
                        />
                    </div>
                    <div className={styles.cell_wrapper}>

                        <span className={styles.col5} />
                    </div>
                    {this.props.prevVisit &&
                        <div className={styles.cell_wrapper}>
                            <span className={styles.col6}>
                                <RedoButton size='extra-small' title='Performed during previous visit' />
                            </span>
                        </div>
                    }
                </div>
            </span>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        removeChildRow: bindActionCreators(noteActions.removeChildRow, dispatch),
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch),
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        clearFields: bindActionCreators(noteActions.clearFields, dispatch),
        hideComputedCharges: bindActionCreators(noteActions.hideComputedCharges, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let xlno = parseInt(Object.keys(state.entities.notes.MLEXLOG)
        .find(key => (state.entities.notes.MLEXLOG[key].XLEVNO === pk && noteType === 1)
            || (state.entities.notes.MLEXLOG[key].XLNTNO === pk && noteType !== 1)));
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let isPeds = state.entities.admissions[epno].isPeds;
    let isPedsEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['PTERO_PEDS_ENABLED'].PRVALUE === 'true' : false;
    let isFederal = state.entities.admissions[epno].isFederal;
    let isWc = state.entities.admissions[epno].isWc;
    let isAuto = state.entities.admissions[epno].isAuto;
    let isOther = (isPedsEnabled && !isPeds && !isFederal && !isWc && !isAuto) || (!isPedsEnabled && !isFederal && !isWc && !isAuto) ? true : false;
    let selfcare = state.entities.notes.MLSELFCARE[ownprops.id];
    let prevVisit = Object.keys(state.entities.notes.MLSELFCAREPREV)
        .find(key => (state.entities.notes.MLSELFCAREPREV[key].NoteId === noteId &&
            state.entities.notes.MLSELFCAREPREV[key].XLSCSCNO === selfcare.XLSCSCNO &&
            state.entities.notes.MLSELFCAREPREV[key].XLSCACTIVITY === selfcare.XLSCACTIVITY
        )) !== undefined ? true : false;
    let plno = parseInt(Object.keys(state.entities.notes.PTPLAN)
        .find(key => (state.entities.notes.PTPLAN[key].PLEVNO === pk && noteType === 1)
            || (state.entities.notes.PTPLAN[key].PLNTNO === pk && noteType !== 1)));
    let onAssessment = state.entities.notes.PTPLAN[plno] && state.entities.notes.PTPLAN[plno].PLSELFCARE ? true : false;
    let computedChargesVisible = state.ui.notes[noteId].computedChargesVisible;

    let activities = state.entities.masterData.MLMASTERSELFCARE ?
        Object.keys(state.entities.masterData.MLMASTERSELFCARE)
            .filter(key => {
                if ((isPedsEnabled && isPeds && state.entities.masterData.MLMASTERSELFCARE[key].SCPEDS) ||
                    (isFederal && state.entities.masterData.MLMASTERSELFCARE[key].SCMC) ||
                    (isWc && state.entities.masterData.MLMASTERSELFCARE[key].SCWC) ||
                    (isAuto && state.entities.masterData.MLMASTERSELFCARE[key].SCAUTO) ||
                    (isOther && state.entities.masterData.MLMASTERSELFCARE[key].SCOTHER)) {
                    return true;
                } else {
                    return false;
                }
            })
            .sort((a, b) => state.entities.masterData.MLMASTERSELFCARE[a].SCNAME.localeCompare(state.entities.masterData.MLMASTERSELFCARE[b].SCNAME))
            .map(key => (
                {
                    id: state.entities.masterData.MLMASTERSELFCARE[key].SCNO,
                    value: state.entities.masterData.MLMASTERSELFCARE[key].SCNAME
                }
            )) : [];
    let performedDisabled = noteType === 3 || noteType === 4 ? true : false;

    return {
        noteId: noteId,
        xlno: xlno,
        selfcare: selfcare,
        activities: activities,
        prevVisit: prevVisit,
        plno,
        onAssessment,
        computedChargesVisible,
        performedDisabled
    };
}

const connectedAlSelfCareRow = connect(mapStateToProps, mapDispatchToProps)(AlSelfCareRow);
export { connectedAlSelfCareRow as AlSelfCareRow };

